<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Prep Task Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`${prep_task.name} Task`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['read prep process']">
      <template #gated-content>
        <b-row class="mb-3">
          <b-col cols="6">
            <b-table-simple borderless striped>
              <b-tbody>
                <b-tr />

                <b-tr>
                  <b-th class="text-nowrap">
                    Name
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.name }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Description
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.description }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Result Type
                  </b-th>
                  <b-td class="w-100">
                    {{ _.startCase(_.toLower(prep_task.result_type)) }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Inspecific Scheduling
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.inspecific_scheduling ? 'True' : 'False' }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Required
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.required ? 'True' : 'False' }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Group
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.group ? 'True' : 'False' }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>

          <b-col cols="6">
            <h4>Export Map</h4>

            <div class="p-2 bg-light">
              <pre>{{ prep_task.export_map || {} }}</pre>
            </div>
          </b-col>
        </b-row>
      </template>
    </permission-alert-gate>

    <permission-alert-gate :permissions="['list analysis']">
      <template #gated-content>
        <div>
          <h3>Analyses</h3>
        </div>

        <AnalysisTable
          :analyses="prep_task.analyses"
          :show_columns="[
            'name',
            'extraction_method',
            'measurement_method'
          ]"
        />
      </template>
    </permission-alert-gate>

    <permission-alert-gate :permissions="['list instrument']">
      <template #gated-content>
        <div>
          <h3>Instruments</h3>
        </div>

        <InstrumentTable
          :instruments="prep_task.instruments"
          :show_columns="[
            'name',
            'abbrev',
            'description',
            'capacity',
            'runtime'
          ]"
        />
      </template>
    </permission-alert-gate>

    <permission-alert-gate :permissions="['list prep task']">
      <template #gated-content>
        <div>
          <h3>
            Quality Controls
            <b-button
              class="float-right"
              variant="success"
              :to="{
                name: 'Add Quality Control',
                params: {
                  sample_type_id: sample_type_id,
                  prep_task: prep_task
                }
              }"
            >
              <i class="fal fa-plus" />
            </b-button>
          </h3>
        </div>

        <WorkflowQualityControlTable
          :schedulable_task_id="prep_task_id"
          schedulable_task_type="PrepTask"
          :show_columns="[
            'name',
            'sheet_label',
            'interval',
            'interval_index'
          ]"
          :show_title="false"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils'
import AnalysisTable from '@/components/lab/analysis/AnalysisTable'
import InstrumentTable from '@/components/lab/instrument/InstrumentTable'
import WorkflowQualityControlTable from '@/components/lab/workflows/WorkflowQualityControlTable.vue'
import { PrepWorkflowRoutes } from '@/router/lab/PrepWorkflowRoutes'

export default {
  name: 'WorkflowPrepTaskDetail',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    AnalysisTable,
    InstrumentTable,
    WorkflowQualityControlTable
  },
  data () {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      prep_process_id: this.$route.params.prep_process_id || null,
      prep_task_id: this.$route.params.prep_task_id || null,
      prep_task: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-search",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.prep_process_id}/${this.prep_task_id}/audit-trail`,
            title: "Audit Trail",
            variant: "dark",
          },
          {
            icon: 'fa-pencil',
            title: 'Edit sample',
            variant: 'warning',
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.prep_process_id}/${this.prep_task_id}/edit`
          }
        ]
      }
    },
    route_root () {
      return PrepWorkflowRoutes.fetchRoot()
    }
  },
  async mounted () {
    this.loading = true

    this.prep_task = await getModel({
      model_type: 'prep_task',
      id: this.prep_task_id,
      message: this.$bvToast
    })

    this.prep_task ? (this.loading = false) : this.$router.back()
  }
}
</script>
